import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);


const index = resolve => {
    require.ensure(['../vue/index.vue'], () => {
        resolve(require('../vue/index.vue'));
    });
}

const bills = resolve => {
    require.ensure(['../vue/bills.vue'], () => {
        resolve(require('../vue/bills.vue'));
    });
}
const addbill = resolve => {
    require.ensure(['../vue/addbill.vue'], () => {
        resolve(require('../vue/addbill.vue'));
    });
}
const w_product = resolve => {
    require.ensure(['../vue/w_product.vue'], () => {
        resolve(require('../vue/w_product.vue'));
    });
}
const stock = resolve => {
    require.ensure(['../vue/stock.vue'], () => {
        resolve(require('../vue/stock.vue'));
    });
}
const login = resolve => {
    require.ensure(['../vue/login.vue'], () => {
        resolve(require('../vue/login.vue'));
    });
}
const recharge = resolve => {
    require.ensure(['../vue/recharge.vue'], () => {
        resolve(require('../vue/recharge.vue'));
    });
}
const mlookup = resolve => {
    require.ensure(['../vue/member_lookup.vue'], () => {
        resolve(require('../vue/member_lookup.vue'));
    });
}
const recharge_log = resolve => {
    require.ensure(['../vue/recharge_log.vue'], () => {
        resolve(require('../vue/recharge_log.vue'));
    });
    }
 const member = resolve => {
    require.ensure(['../vue/members.vue'], () => {
        resolve(require('../vue/members.vue'));
    });
    }
 const addstore = resolve => {
    require.ensure(['../vue/addstore.vue'], () => {
        resolve(require('../vue/addstore.vue'));
    });
    }
 const ts = resolve => {
    require.ensure(['../vue/ts_list.vue'], () => {
        resolve(require('../vue/ts_list.vue'));
    });
    }
 const wait_list = resolve => {
    require.ensure(['../vue/wait_list.vue'], () => {
        resolve(require('../vue/wait_list.vue'));
    });
    }
const order_report = resolve => {
    require.ensure(['../vue/order_report.vue'], () => {
        resolve(require('../vue/order_report.vue'));
    });
    }
    const stock_report = resolve => {
        require.ensure(['../vue/stock_report.vue'], () => {
            resolve(require('../vue/stock_report.vue'));
        });
        }
const routes = [
    {
        path: '/login',
        name: 'login',
        component: login
    },{
        path: '/index',
        name: 'index',
        component: index
    },{
        path: '/',
        name: 'index',
        component: index
    },{
        path: '/bills',
        name: 'bills',
        component: bills
    },{
        path: '/addbill',
        name: 'addbill',
        component: addbill
    },{
        path: '/w_product',
        name: 'w_product',
        component: w_product
    },{
        path: '/stock',
        name: 'stock',
        component: stock
    },
    {
        path: '/recharge',
        name: 'recharge',
        component: recharge
    },
    {
        path: '/mlookup',
        name: 'mlookup',
        component: mlookup
    },
    {
        path: '/recharge_log',
        name: 'recharge_log',
        component: recharge_log
    },
    {
        path: '/member',
        name: 'member',
        component: member
    },
     {
        path: '/addstore',
        name: 'addstore',
        component: addstore
    },{
        path: '/ts',
        name: 'ts',
        component: ts
    },{
        path: '/wait_list',
        name: 'wait_list',
        component: wait_list
    },{
        path: '/order_report',
        name: 'order_report',
        component: order_report
    },
    {
        path: '/stock_report',
        name: 'stock_report',
        component: stock_report
    },
   ];

export default new Router({
    routes
});



// WEBPACK FOOTER //
// ./src/router/index.js